/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

export type TradeSettingsVariant = 'default' | 'fees'

export type OpenTradeSettingsDialogParams = {
  mode?: 'dialog' | 'drawer'
}

export const openTradeSettingsDialogEvent =
  action<OpenTradeSettingsDialogParams>('openTradeSettingsDialogEvent')

export const openQuickBuyTradeSettingsDialogAction = action((ctx) => {
  openTradeSettingsDialogEvent(ctx, {
    mode: 'drawer',
  })
})
